var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisualization1 = function SvgVisualization1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#204969",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.214 61h21.143A2.65 2.65 0 0 0 61 58.357V37.214H37.214zm21.143-37H26.643A2.65 2.65 0 0 0 24 26.643v7.928h37v-7.928A2.65 2.65 0 0 0 58.357 24M24 58.357A2.65 2.65 0 0 0 26.643 61h7.928V37.214H24z"
  })));
};
export default SvgVisualization1;